export class CardLogin {
    UID: string;
    PIN: string;
}